
import posterAvif from '@shared/ui/images/schedule/success-poster.avif'
import posterWebp from '@shared/ui/images/schedule/success-poster.webp'
import posterSmartestmindsAvif from '@shared/ui/images/schedule/success-poster-smartestminds.avif'
import posterSmartestmindsWebp from '@shared/ui/images/schedule/success-poster-smartestminds.webp'
import { AppBrand } from '@shared/config'

export interface SuccessPoster {
  avif: string
  webp: string
}

const posterByBrand: Record<AppBrand, SuccessPoster> = {
  [AppBrand.Brighterly]: { avif: posterAvif, webp: posterWebp },
  [AppBrand.SmartestMinds]: { avif: posterSmartestmindsAvif, webp: posterSmartestmindsWebp },
}

export const getSuccessPoster = (): SuccessPoster => posterByBrand[useRuntimeConfig().public.brand]
